import { AjaxFormValidation } from '@common/libs/ajax-form-validation';

export const AboutPartner = {

    $form : $('#partnersModal form'), 
    
    /**
     * Bind form validation
     */
    initFormValidation() {
        let validator = new AjaxFormValidation(this.$form);

        this.$form.on('blur', '#PartnerName, #PartnerEmail, #PartnerCompanyWebsite, #PartnerMessage', function(e) {
            validator.validate(this, {clientOnly: true});
        })
        // Form submission
        .on('click', '[type="submit"]', (e) => {
            e.preventDefault();
            if (!validator.valid()) {
               return false;
            }

            let $btn = $(e.currentTarget), $btnSubmitting = this.$form.find('.btn-submitting');
            $btn.hide();
            $btnSubmitting.show();
            
            $.ajax({
                type: 'POST',
                url: this.$form.attr('action'),
                data: this.$form.serialize(),
                dataType: 'json'
            }).done((response) => {
                $btn.show();
                $btnSubmitting.hide();

                // Submitted
                if (response.success) {
                    $('#PartnerName, #PartnerEmail, #PartnerCompanyWebsite, #PartnerMessage').val('');
                    validator.reset();
                    this.addSuccessMessage('Thanks! We\'ve received your application. We\'ll be in touch within 5 working days');
                    return;
                }

                // Unable to submit the application
                if (response.error) {
                    this.addErrorMessage(response.error);
                    return;
                }
            });

        });
    },

    addSuccessMessage(message) {
        this.$form.find('.alert-success').html(message).show();
        this.$form.find('.alert-danger').html('').hide();
    },

    addErrorMessage(message) {
        this.$form.find('.alert-danger').html(message).show(); 
        this.$form.find('.alert-success').html('').hide();
    }

}